import {Injectable} from '@angular/core';
import {VisbosService} from "../../../core/visbos-core/graphql/visbos.service";
import {Apollo, ApolloQueryObservable} from "apollo-angular";
import {NgRedux} from "@angular-redux/store";
import {IAppState} from "../../../shared/redux-store/store";
import {SessionActions} from "../../../shared/actions/session.actions";
import gql from "graphql-tag";
import {Observable} from "rxjs/Observable";
import {MultiDateSeries} from "../../../shared/view-model/core/multi-date-series.type";
import {MultiSeries} from "../../../shared/view-model/core/multi-series.type";
import {
  ConsumptionByConsumerByTimeStatisticsQuery,
  ConsumptionByConsumerStatisticsQuery,
  ConsumptionByTypeByTimeStatisticsQuery,
  ConsumptionByTypeStatisticsQuery,
  CostsBySupplierByTimeStatisticsQuery,
  CostsBySupplierStatisticsQuery,
  OrdersBySupplierStatisticsQuery
} from "../../../shared/graphql/graphql.types";
import {environment} from '../../../../environments/environment';
import {HttpClient, HttpHeaders} from '@angular/common/http';

export const exportAccountStatisticsEndpoint = environment.exportUrl + 'accounting-statistics/:adminUnitCuid';

export const consumptionByConsumerStatisticsQuery = gql`
  query ConsumptionByConsumerStatistics($adminUnitCuid: String!, $depotCuid: String, $startDate: String, $endDate: String) {
    consumptionByConsumerStatistics(adminUnitCuid: $adminUnitCuid, depotCuid: $depotCuid, startDate: $startDate, endDate: $endDate) { name, value }
  }
`;

export const consumptionByConsumerByTimeStatisticsQuery = gql`
  query ConsumptionByConsumerByTimeStatistics($adminUnitCuid: String!, $depotCuid: String, $startDate: String, $endDate: String, $groupingByTime: String!) {
    consumptionByConsumerByTimeStatistics(adminUnitCuid: $adminUnitCuid, depotCuid: $depotCuid, startDate: $startDate, endDate: $endDate, groupingByTime: $groupingByTime) { name, series {name, value} }
  }
`;

export const consumptionByTypeStatisticsQuery = gql`
  query ConsumptionByTypeStatistics($adminUnitCuid: String!, $depotCuid: String, $startDate: String, $endDate: String) {
    consumptionByTypeStatistics(adminUnitCuid: $adminUnitCuid, depotCuid: $depotCuid, startDate: $startDate, endDate: $endDate) { name, value }
  }
`;

export const consumptionByTypeByTimeStatisticsQuery = gql`
  query ConsumptionByTypeByTimeStatistics($adminUnitCuid: String!, $depotCuid: String, $startDate: String, $endDate: String, $groupingByTime: String!) {
    consumptionByTypeByTimeStatistics(adminUnitCuid: $adminUnitCuid, depotCuid: $depotCuid, startDate: $startDate, endDate: $endDate, groupingByTime: $groupingByTime) { name, series {name, value} }
  }
`;

export const ordersBySupplierStatisticsQuery = gql`
  query OrdersBySupplierStatistics($adminUnitCuid: String!, $supplierCuid: String, $startDate: String, $endDate: String) {
    ordersBySupplierStatistics(adminUnitCuid: $adminUnitCuid, supplierCuid: $supplierCuid, startDate: $startDate, endDate: $endDate, ) { name, value }
  }
`;

export const costsBySupplierStatisticsQuery = gql`
  query CostsBySupplierStatistics($adminUnitCuid: String!, $supplierCuid: String, $startDate: String, $endDate: String) {
    costsBySupplierStatistics(adminUnitCuid: $adminUnitCuid, supplierCuid: $supplierCuid, startDate: $startDate, endDate: $endDate, ) { name, value }
  }
`;

export const costsBySupplierByTimeStatisticsQuery = gql`
  query CostsBySupplierByTimeStatistics($adminUnitCuid: String!, $supplierCuid: String, $startDate: String, $endDate: String, $groupingByTime: String!) {
    costsBySupplierByTimeStatistics(adminUnitCuid: $adminUnitCuid, supplierCuid: $supplierCuid, startDate: $startDate, endDate: $endDate, groupingByTime: $groupingByTime) { name, series {name, value} }
  }
`;


@Injectable()
export class StoreStatisticsService extends VisbosService {


  constructor(apollo: Apollo, ngRedux: NgRedux<IAppState>, sessionActions: SessionActions, private http: HttpClient) {
    super(apollo, ngRedux, sessionActions);
  }

  getConsumptionByConsumerStatistics(adminUnitCuid?: string | Observable<string>, depotCuid?: string | Observable<string>, startDate?: string | Observable<string>, endDate?: string | Observable<string>): ApolloQueryObservable<ConsumptionByConsumerStatisticsQuery> {
    return this.fetchItems({
      query: consumptionByConsumerStatisticsQuery,
      variables: {
        adminUnitCuid: adminUnitCuid || this.activeAdminUnitCuid$,
        depotCuid: depotCuid,
        startDate: startDate,
        endDate: endDate
      }
    });
  }

  getConsumptionByConsumerByTimeStatistics(groupingByTime: string | Observable<string> = 'Y-d', adminUnitCuid?: string | Observable<string>, depotCuid?: string | Observable<string>, startDate?: string | Observable<string>,
                                           endDate?: string | Observable<string>): ApolloQueryObservable<ConsumptionByConsumerByTimeStatisticsQuery> {
    return this.fetchItems({
      query: consumptionByConsumerByTimeStatisticsQuery,
      variables: {
        adminUnitCuid: adminUnitCuid || this.activeAdminUnitCuid$,
        depotCuid: depotCuid,
        startDate: startDate,
        endDate: endDate,
        groupingByTime: groupingByTime
      }
    });
  }

  getConsumptionByTypeStatistics(adminUnitCuid?: string | Observable<string>, depotCuid?: string | Observable<string>, startDate?: string | Observable<string>, endDate?: string | Observable<string>): ApolloQueryObservable<ConsumptionByTypeStatisticsQuery> {
    return this.fetchItems({
      query: consumptionByTypeStatisticsQuery,
      variables: {
        adminUnitCuid: adminUnitCuid || this.activeAdminUnitCuid$,
        depotCuid: depotCuid,
        startDate: startDate,
        endDate: endDate
      }
    });
  }

  getConsumptionByTypeByTimeStatistics(groupingByTime: string | Observable<string> = 'Y-d', adminUnitCuid?: string | Observable<string>, depotCuid?: string | Observable<string>, startDate?: string | Observable<string>,
                                       endDate?: string | Observable<string>): ApolloQueryObservable<ConsumptionByTypeByTimeStatisticsQuery> {
    return this.fetchItems({
      query: consumptionByTypeByTimeStatisticsQuery,
      variables: {
        adminUnitCuid: adminUnitCuid || this.activeAdminUnitCuid$,
        depotCuid: depotCuid,
        startDate: startDate,
        endDate: endDate,
        groupingByTime: groupingByTime
      }
    });
  }

  getOrdersBySuppliersStatistics(adminUnitCuid?: string | Observable<string>, supplierCuid?: string | Observable<string>, startDate?: string | Observable<string>, endDate?: string | Observable<string>): ApolloQueryObservable<OrdersBySupplierStatisticsQuery> {
    return this.fetchItems({
      query: ordersBySupplierStatisticsQuery,
      variables: {
        adminUnitCuid: adminUnitCuid || this.activeAdminUnitCuid$,
        supplierCuid: supplierCuid,
        startDate: startDate,
        endDate: endDate
      }
    });
  }

  getCostsBySupplierStatistics(adminUnitCuid?: string | Observable<string>, supplierCuid?: string | Observable<string>, startDate?: string | Observable<string>, endDate?: string | Observable<string>): ApolloQueryObservable<CostsBySupplierStatisticsQuery> {
    return this.fetchItems({
      query: costsBySupplierStatisticsQuery,
      variables: {
        adminUnitCuid: adminUnitCuid || this.activeAdminUnitCuid$,
        supplierCuid: supplierCuid,
        startDate: startDate,
        endDate: endDate
      }
    });
  }

  getCostsBySupplierByTimeStatistics(groupingByTime: string | Observable<string> = 'Y-d', adminUnitCuid?: string | Observable<string>, supplierCuid?: string | Observable<string>, startDate?: string | Observable<string>,
                                     endDate?: string | Observable<string>): ApolloQueryObservable<CostsBySupplierByTimeStatisticsQuery> {
    return this.fetchItems({
      query: costsBySupplierByTimeStatisticsQuery,
      variables: {
        adminUnitCuid: adminUnitCuid || this.activeAdminUnitCuid$,
        supplierCuid: supplierCuid,
        startDate: startDate,
        endDate: endDate,
        groupingByTime: groupingByTime
      }
    });
  }

  generateAccountStatisticsExport(adminUnitCuid) {
    const headers = new HttpHeaders();
    headers.set('Accept', 'text/plain');
    return this.http.get(exportAccountStatisticsEndpoint.replace(':adminUnitCuid', adminUnitCuid), {
      headers,
      responseType: 'arraybuffer',
      observe: 'response'
    });
  }

  transformMultiSeriesToDateSeries(input: MultiSeries[]): MultiDateSeries[] {
    let multi = JSON.parse(JSON.stringify(input));
    return multi.map(group => {
      group.series = group.series.map(dataItem => {
        dataItem.name = new Date(dataItem.name);
        return dataItem;
      });
      return group;
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/store-management/services/statistics-services/store-statistics.service.ts